import { render } from "./SlideUpTransition.vue?vue&type=template&id=70f22c3b"
const script = {}

import "./SlideUpTransition.vue?vue&type=style&index=0&id=70f22c3b&lang=css"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__